export default "__VITE_ASSET__C2stnxa0__"